/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnactions3Inputs */

const en_ticketpagecolumnactions3 = /** @type {(inputs: Ticketpagecolumnactions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_ticketpagecolumnactions3 = /** @type {(inputs: Ticketpagecolumnactions3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Ticketpagecolumnactions3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnactions3 = /** @type {((inputs?: Ticketpagecolumnactions3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnactions3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnactions3(inputs)
	return de_ticketpagecolumnactions3(inputs)
});
export { ticketpagecolumnactions3 as "ticketPageColumnActions" }